import { useState } from "react";
import { Droplets, Shield, Sparkles, ChevronDown } from "lucide-react";

const items = [
  { icon: Shield, label: "Leak-Proof", text: "Travel with confidence. Our seal design keeps every drop inside." },
  { icon: Sparkles, label: "Easy Refill", text: "Remove the glass vial to refill. Works with any perfume, no adapters needed." },
  { icon: Droplets, label: "Premium Vegan Leather", text: "Each 10ml atomizer is wrapped in soft, pebbled premium vegan leather." },
];

const FeatureStrip = () => {
  const [open, setOpen] = useState<number | null>(null);
  const active = open !== null ? items[open] : null;

  return (
    <div className="border-y border-border bg-secondary/40">
      <ul className="container mx-auto px-6 py-4 flex flex-wrap items-center justify-center gap-x-10 gap-y-2">
        {items.map(({ icon: Icon, label }, i) => (
          <li key={label}>
            <button
              type="button"
              onClick={() => setOpen(open === i ? null : i)}
              aria-expanded={open === i}
              className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-foreground hover:text-primary transition-colors"
            >
              <Icon className="w-4 h-4 text-primary" aria-hidden="true" />
              {label}
              <ChevronDown className={`w-3 h-3 transition-transform ${open === i ? "rotate-180" : ""}`} aria-hidden="true" />
            </button>
          </li>
        ))}
      </ul>
      <div className={`grid transition-all duration-300 ease-out ${active ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
        <div className="overflow-hidden">
          {active && (
            <p className="container mx-auto px-6 pb-5 text-center text-sm text-muted-foreground">
              {active.text}{" "}
              <a href="/#craft" className="text-primary underline underline-offset-4 whitespace-nowrap">
                Discover the craft
              </a>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeatureStrip;
